import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from "./utils/common";

// 引入自适应
import "@/utils/rem.js";

//注册ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
//umy-ui
import UmyUi from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
Vue.use(UmyUi);

import tinymce from "tinymce";
Vue.use(tinymce);

// 引入打印插件
import Print from "vue-print-nb";
Vue.use(Print);

//全局引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 富文本
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

//挂载总线
Vue.prototype.$bus = new Vue();
//挂载通用工具方式
Vue.prototype.$utils = utils;
//挂载手动取消请求方法
Vue.prototype.$cancelQequest = () => {
  // 获取缓存的 请求取消标识 数组，取消所有关联的请求
  const cancelArr = window.axiosCancel || [];
  cancelArr.forEach((item) => {
    item.cancel("请求终止"); // 在失败函数中返回这里自定义的错误信息
  });
  window.axiosCancel = [];
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
